import * as yup from 'yup';
import { OPTIONAL_SERVICE_COD, OPTIONAL_SERVICE_INSURANCE } from '../../../../constants/data/registerShipmentData';

export interface IStepOptionalServicesFormInfo {
	optionalServices: string[];
	optionalServicesNames: any[];
	codAmount: string;
	codSsn: string;
	codBank: string;
	codAccountType: string;
	codAccount: string;
	codReference: string;
	insuranceAmount: string;
}

export const stepOptionalServicesInitialValues: IStepOptionalServicesFormInfo = {
	optionalServices: [],
	optionalServicesNames: [],
	codAmount: '',
	codSsn: '',
	codBank: '',
	codAccountType: '',
	codAccount: '',
	codReference: '',
	insuranceAmount: '',
};

export const StepOptionalServicesSchema = yup.object().shape({
	optionalServices: yup.array().of(yup.string()),
	optionalServicesNames: yup.array().of(yup.string()),
	codAmount: yup.string().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.string()
			.matches(/^[0-9]*$/, 'step-optional-services.only-numbers')
			.required('step-optional-services.amount-required'),
	}),
	codSsn: yup.string().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.string()
			.min(10)
			.max(10, 'step-info.max')
			.required('step-optional-services.ssn-required'),
	}),
	codBank: yup.string().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.string()
			.max(4, 'step-info.max')
			.required('step-optional-services.bank-required'),
	}),
	codAccountType: yup.string().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.string()
			.required('step-optional-services.account-type-required')
			.test('length', 'step-optional-services.account-type-length', val => val && val.length === 2),
	}),
	codAccount: yup.string().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.string()
			.max(6, 'step-info.max')
			.required('step-optional-services.account-required'),
	}),
	codReference: yup.number().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_COD),
		then: yup
			.number()
			.max(9999999, 'step-optional-services.reference-length')
			.typeError('step-optional-services.reference-type'),
	}),
	insuranceAmount: yup.number().when('optionalServices', {
		is: optionalServices => optionalServices.includes(OPTIONAL_SERVICE_INSURANCE),
		then: yup
			.number()
			.required('step-optional-services.amount')
			.min(500, 'step-optional-services.amount-min')
			.max(3000000, 'step-optional-services.amount-max')
			.typeError('step-optional-services.amount-type'),
	}),
});
